import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bot } from "lucide-react";
import api from "@/lib/api";

// The 20 NarrativeSync agents mapped onto MusicFlow features.
export default function AgentsGrid() {
  const [agents, setAgents] = useState([]);
  useEffect(() => { api.get("/agents").then(({ data }) => setAgents(data.agents)).catch(() => {}); }, []);
  if (!agents.length) return null;
  return (
    <section className="space-y-3" data-testid="agents-grid">
      <h2 className="text-base md:text-lg font-semibold flex items-center gap-2"><Bot size={16} className="text-primary" /> The 20 agents behind the engine</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
        {agents.map((a) => (
          <Link key={a.name} to={a.route} className="rounded-xl border border-border bg-card/60 p-3 hover:border-primary/50 transition-colors" data-testid={`agent-${a.name}`}>
            <div className="flex items-center justify-between gap-2">
              <span className="font-mono text-xs font-semibold">{a.name}</span>
              <span className={`text-[9px] uppercase tracking-wide px-1.5 py-0.5 rounded-full border ${a.status === "built" ? "text-emerald-400 border-emerald-500/30" : "text-muted-foreground border-border"}`}>{a.status === "built" ? "new" : "live"}</span>
            </div>
            <p className="text-[11px] text-muted-foreground mt-1 leading-snug">{a.role}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
